import { defineMessages } from 'react-intl';

const messages = defineMessages({
  studyAbroadCredit: {
    id: 'premium-menu.student.life.studyAbroadCredit',
    defaultMessage: 'Study Abroad Credit',
  },
  studyAbroadNonCredit: {
    id: 'premium-menu.student.life.studyAbroadNonCredit',
    defaultMessage: 'Study Abroad NonCredit',
  },
  graduateStudyAbroadCredit: {
    id: 'premium-menu.student.life.graduateStudyAbroadCredit',
    defaultMessage: 'Graduate Study Abroad Credit',
  },
  graduateStudyAbroadNonCredit: {
    id: 'premium-menu.student.life.graduateStudyAbroadNonCredit',
    defaultMessage: 'Graduate Study Abroad NonCredit',
  },
  studyAbroad: {
    id: 'premium-menu.student.life.studyAbroad',
    defaultMessage: 'Study Abroad',
  },
  graduateStudyAbroad: {
    id: 'premium-menu.student.life.graduateStudyAbroad',
    defaultMessage: 'Graduate Study Abroad',
  },
  teacherCertificationPrograms: {
    id: 'premium-menu.student.life.teacherCertificationPrograms',
    defaultMessage: 'Teacher Certification Programs',
  },
  combinedDegreePrograms: {
    id: 'premium-menu.student.life.combinedDegreePrograms',
    defaultMessage: 'Combined Degree Programs',
  },
  domesticStudyAwayPrograms: {
    id: 'premium-menu.student.life.domesticStudyAwayPrograms',
    defaultMessage: 'Domestic Study Away Programs',
  },
  weekendEveningPrograms: {
    id: 'premium-menu.student.life.weekendEveningPrograms',
    defaultMessage: 'Weekend Evening Programs',
  },
  acceleratedProgram: {
    id: 'premium-menu.student.life.acceleratedProgram',
    defaultMessage: 'Accelerated Program',
  },
  doubleMajor: {
    id: 'premium-menu.student.life.doubleMajor',
    defaultMessage: 'Double Major',
  },
  externalDegreeProgram: {
    id: 'premium-menu.student.life.externalDegreeProgram',
    defaultMessage: 'External Degree Program',
  },
  honorsProgram: {
    id: 'premium-menu.student.life.honorsProgram',
    defaultMessage: 'Honors Program',
  },
  independentStudy: {
    id: 'premium-menu.student.life.independentStudy',
    defaultMessage: 'Independent Study',
  },
  internships: {
    id: 'premium-menu.student.life.internships',
    defaultMessage: 'Internships',
  },
  weekendCollege: {
    id: 'premium-menu.student.life.weekendCollege',
    defaultMessage: 'Weekend College',
  },
  cooperativeEducationPrograms: {
    id: 'premium-menu.student.life.cooperativeEducationPrograms',
    defaultMessage: 'Cooperative Education Programs',
  },
  academicCareerCounseling: {
    id: 'premium-menu.student.life.academicCareerCounseling',
    defaultMessage: 'Academic/Career Counseling',
  },
  accommodationsForStudentsWithADHD: {
    id: 'premium-menu.student.life.accommodationsForStudentsWithADHD',
    defaultMessage: 'Accommodations for Students with ADHD',
  },
  assistanceForHearingImpaired: {
    id: 'premium-menu.student.life.assistanceForHearingImpaired',
    defaultMessage: ' Assistance for Hearing Impaired',
  },
  assistanceForMobilityImpaired: {
    id: 'premium-menu.student.life.assistanceForMobilityImpaired',
    defaultMessage: ' Assistance for Mobility Impaired',
  },
  assistanceForVisuallyImpaired: {
    id: 'premium-menu.student.life.assistanceForVisuallyImpaired',
    defaultMessage: 'Assistance for Visually Impaired',
  },
  bookOnTapeForRFBD: {
    id: 'premium-menu.student.life.bookOnTapeForRFBD',
    defaultMessage: 'Book on Tape for RFBD',
  },
  calculatorsAllowedInExams: {
    id: 'premium-menu.student.life.calculatorsAllowedInExams',
    defaultMessage: 'Calculators Allowed in Exams',
  },
  computersAllowedInExams: {
    id: 'premium-menu.student.life.computersAllowedInExams',
    defaultMessage: 'Computers Allowed in Exams',
  },
  dayCareServices: {
    id: 'premium-menu.student.life.dayCareServices',
    defaultMessage: ' Day Care Services',
  },
  dictionaryAllowedInExams: {
    id: 'premium-menu.student.life.dictionaryAllowedInExams',
    defaultMessage: 'Dictionary Allowed in Exams',
  },
  ESL: {
    id: 'premium-menu.student.life.ESL',
    defaultMessage: 'ESL (English as Second Language)',
  },
  healthServicesAvailable: {
    id: 'premium-menu.student.life.healthServicesAvailable',
    defaultMessage: 'Health Services Available',
  },
  internshipsWithPay: {
    id: 'premium-menu.student.life.internshipsWithPay',
    defaultMessage: 'Internships with Pay',
  },
  internshipsWithoutPay: {
    id: 'premium-menu.student.life.internshipsWithoutPay',
    defaultMessage: ' Internships without Pay',
  },
  jobPlacement: {
    id: 'premium-menu.student.life.jobPlacement',
    defaultMessage: 'Job Placement',
  },
  LDSpecialists: {
    id: 'premium-menu.student.life.LDSpecialists',
    defaultMessage: 'LD Specialists',
  },
  learningCenter: {
    id: 'premium-menu.student.life.learningCenter',
    defaultMessage: 'Learning Center',
  },
  libraryFacilities: {
    id: 'premium-menu.student.life.libraryFacilities',
    defaultMessage: 'Library Facilities',
  },
  peerTutors: {
    id: 'premium-menu.student.life.peerTutors',
    defaultMessage: 'Peer Tutors',
  },
  professionalTutors: {
    id: 'premium-menu.student.life.professionalTutors',
    defaultMessage: 'Professional Tutors',
  },
  readingMachine: {
    id: 'premium-menu.student.life.readingMachine',
    defaultMessage: 'Reading Machine',
  },
  remedialServices: {
    id: 'premium-menu.student.life.remedialServices',
    defaultMessage: ' Remedial Services',
  },
  spellcheckerAllowedInExam: {
    id: 'premium-menu.student.life.spellcheckerAllowedInExam',
    defaultMessage: 'Spellchecker Allowed in Exam',
  },
  studentEmployment: {
    id: 'premium-menu.student.life.studentEmployment',
    defaultMessage: 'Student Employment',
  },
  tapeRecordingInClass: {
    id: 'premium-menu.student.life.tapeRecordingInClass',
    defaultMessage: 'Tape Recording in Class',
  },
  tapingOfBooksNotFromRFBD: {
    id: 'premium-menu.student.life.tapingOfBooksNotFromRFBD',
    defaultMessage: 'Taping of Books not from RFBD',
  },
  veteran: {
    id: 'premium-menu.student.life.veteran',
    defaultMessage: 'Veteran',
  },
  aspergersAutismSupportServices: {
    id: 'premium-menu.student.life.aspergersAutismSupportServices',
    defaultMessage: 'Aspergers/Autism Support Services',
  },
  ROTCArmy: {
    id: 'premium-menu.student.life.ROTCArmy',
    defaultMessage: 'ROTC Army',
  },
  ROTCNavy: {
    id: 'premium-menu.student.life.ROTCNavy',
    defaultMessage: 'ROTC Navy',
  },
  ROTCAirforce: {
    id: 'premium-menu.student.life.ROTCAirforce',
    defaultMessage: 'ROTC Airforce',
  },
  ROTCServicepersonOpportunityCollege: {
    id: 'premium-menu.student.life.ROTCServicepersonOpportunityCollege',
    defaultMessage: 'ROTC Serviceperson Opportunity College',
  },
  academicClubs: {
    id: 'premium-menu.student.life.academicClubs',
    defaultMessage: 'Academic Clubs',
  },
  academicFratSor: {
    id: 'premium-menu.student.life.academicFratSor',
    defaultMessage: 'Academic Frat./Sor.',
  },
  business: {
    id: 'premium-menu.student.life.business',
    defaultMessage: 'Business',
  },
  choir: {
    id: 'premium-menu.student.life.choir',
    defaultMessage: 'Choir',
  },
  commuter: {
    id: 'premium-menu.student.life.commuter',
    defaultMessage: 'Commuter',
  },
  concertBand: {
    id: 'premium-menu.student.life.concertBand',
    defaultMessage: 'Concert Band',
  },
  environmental: {
    id: 'premium-menu.student.life.environmental',
    defaultMessage: 'Environmental',
  },
  gayAndLesbian: {
    id: 'premium-menu.student.life.gayAndLesbian',
    defaultMessage: 'LGBTQ+',
  },
  honorsAcademic: {
    id: 'premium-menu.student.life.honorsAcademic',
    defaultMessage: 'Honors/Academic',
  },
  international: {
    id: 'premium-menu.student.life.international',
    defaultMessage: 'International',
  },
  jazzBand: {
    id: 'premium-menu.student.life.jazzBand',
    defaultMessage: 'Jazz Band',
  },
  literaryMagazine: {
    id: 'premium-menu.student.life.literaryMagazine',
    defaultMessage: 'Literary Magazine',
  },
  marchingBand: {
    id: 'premium-menu.student.life.marchingBand',
    defaultMessage: 'Marching Band',
  },
  minorityCultural: {
    id: 'premium-menu.student.life.minorityCultural',
    defaultMessage: 'Cultural Awareness',
  },
  minorityStudent: {
    id: 'premium-menu.student.life.minorityStudent',
    defaultMessage: 'Minority Student Programs',
  },
  newspaper: {
    id: 'premium-menu.student.life.newspaper',
    defaultMessage: 'Newspaper',
  },
  orchestra: {
    id: 'premium-menu.student.life.orchestra',
    defaultMessage: 'Orchestra',
  },
  phiBetaKappa: {
    id: 'premium-menu.student.life.phiBetaKappa',
    defaultMessage: 'Phi Beta Kappa',
  },
  physicallyChallenged: {
    id: 'premium-menu.student.life.physicallyChallenged',
    defaultMessage: 'Students with Disabilities',
  },
  politicalActivism: {
    id: 'premium-menu.student.life.politicalActivism',
    defaultMessage: 'Political Activism',
  },
  preDental: {
    id: 'premium-menu.student.life.preDental',
    defaultMessage: 'Pre-Dental',
  },
  preLaw: {
    id: 'premium-menu.student.life.preLaw',
    defaultMessage: 'Pre-Law',
  },
  preMedical: {
    id: 'premium-menu.student.life.preMedical',
    defaultMessage: 'Pre-Medical',
  },
  preVeterinary: {
    id: 'premium-menu.student.life.preVeterinary',
    defaultMessage: 'Pre-Veterinary',
  },
  radioStation: {
    id: 'premium-menu.student.life.radioStation',
    defaultMessage: 'Radio Station',
  },
  religious: {
    id: 'premium-menu.student.life.religious',
    defaultMessage: 'Religious',
  },
  sportsIntramurals: {
    id: 'premium-menu.student.life.sportsIntramurals',
    defaultMessage: 'Sports/Intramurals',
  },
  studentGovernment: {
    id: 'premium-menu.student.life.studentGovernment',
    defaultMessage: 'Student Government',
  },
  substanceAbuseSupport: {
    id: 'premium-menu.student.life.substanceAbuseSupport',
    defaultMessage: 'Substance Abuse Support',
  },
  televisionStation: {
    id: 'premium-menu.student.life.televisionStation',
    defaultMessage: 'Television Station',
  },
  theatreDrama: {
    id: 'premium-menu.student.life.theatreDrama',
    defaultMessage: 'Theatre/Drama',
  },
  yearbook: {
    id: 'premium-menu.student.life.yearbook',
    defaultMessage: 'Yearbook',
  },
  phiThetaKappa: {
    id: 'premium-menu.student.life.phiThetaKappa',
    defaultMessage: 'Phi Theta Kappa',
  },
  field_he_counseling_services: {
    id: 'premium-menu.student.life.field_he_counseling_services',
    defaultMessage: 'Counseling Services',
  },
});

export default messages;
